export default __webpack_public_path__ + "static/media/forty_percent_blue.3731a41b.svg";